import { InjectionToken, Signal, WritableSignal, inject } from '@angular/core';
import { MapStateService } from '@wheere-front/domain-trackers';
import { MapStyle, MapStyleType } from '@wheere-front/shared-map-libre';

/** Style de la carte d'aperçu (rue / satellite), partagé avec les autres cartes de l'app. */
export interface SiteConfigMapState {
  mapStyleType: WritableSignal<MapStyleType>;
  mapStyle: Signal<MapStyle>;
  onToggleMapStyle(): void;
}

/** Par défaut : l'état de carte partagé de `domain-trackers` (clé `MAPTILES_KEY`). Inside le
 * remplace par son propre `MapStateService` pour garder le même interrupteur que ses autres cartes. */
export const SITE_CONFIG_MAP_STATE = new InjectionToken<SiteConfigMapState>('SITE_CONFIG_MAP_STATE', {
  providedIn: 'root',
  factory: (): SiteConfigMapState => inject(MapStateService),
});
